import { GameObjects } from 'phaser';
import { ARCADE_HEX, ARCADE_TEXT } from '../config/theme';
import { MolduraPixel } from './MolduraPixel';
import { ICONE_DO_INDICADOR } from './PainelIndicadores';

const LARGURA = 255, ALTURA = 142;
const CHANFRO = { esq: true, dir: true, tamanho: 13 };
const ESTADOS = {
    normal: { fundo: ARCADE_HEX.BRANCO, fio: ARCADE_HEX.FIO_CAMPO, fioMeio: ARCADE_HEX.BRANCO },
    escolhida: { fundo: 0xcbff61, fio: ARCADE_HEX.VERDE, fioMeio: 0xcbff61 },
    apagada: { fundo: 0xd9d9d9, fio: 0x8a8a8a, fioMeio: 0xd9d9d9 }
};

/**
 * Alternativa de um capítulo do Player 1 (Figma, quadro 4): a ação em
 * Barlow e, no rodapé preto, o impacto em cada indicador. Sem `impactos`
 * o rodapé não existe e o texto ocupa o cartão inteiro.
 */
export class CartaoDecisao extends GameObjects.Container {
    constructor (scene, x, y, { texto, impactos = [], aoTocar = null }) {
        super(scene, x, y);
        scene.add.existing(this);
        this.temRodape = impactos.length > 0;

        this.moldura = scene.add.graphics();
        this.add(this.moldura);

        // O texto encolhe até caber na área branca.
        const areaAltura = this.temRodape ? 86 : 122;
        this.texto = scene.add.text(LARGURA / 2, 10 + areaAltura / 2, texto, {
            ...ARCADE_TEXT.opcao, align: 'center', wordWrap: { width: 222 }
        }).setOrigin(0.5);
        for (const tamanho of [18, 17, 16, 15, 14, 13, 12]) {
            this.texto.setFontSize(tamanho);
            if (this.texto.height <= areaAltura - 10) break;
        }
        this.add(this.texto);

        if (this.temRodape) {
            // Quatro impactos só cabem com ícone e número um pouco menores.
            const apertado = impactos.length > 3;
            const itens = impactos.map(({ chave, texto: delta }) => {
                const icone = scene.add.image(0, 116, ICONE_DO_INDICADOR[chave]).setOrigin(0, 0.5).setScale(apertado ? 0.5 : 0.62);
                const valor = scene.add.text(0, 116, delta, { ...ARCADE_TEXT.botao, fontSize: apertado ? '14px' : '17px' }).setOrigin(0, 0.5);
                return { icone, valor, largura: icone.displayWidth + (apertado ? 3 : 5) + valor.width };
            });
            const vao = apertado ? 5 : 10;
            let cx = LARGURA / 2 - (itens.reduce((soma, item) => soma + item.largura, 0) + vao * (itens.length - 1)) / 2;
            itens.forEach((item) => {
                item.icone.x = cx;
                item.valor.x = cx + item.largura - item.valor.width;
                cx += item.largura + vao;
                this.add([item.icone, item.valor]);
            });
        }

        this.setSize(LARGURA, ALTURA);
        this.zona = scene.add.zone(LARGURA / 2, ALTURA / 2, LARGURA, ALTURA)
            .setInteractive({ useHandCursor: true })
            .on('pointerup', () => this.zona.input.enabled && aoTocar?.(this));
        this.add(this.zona);

        this.setEstado('normal');
    }

    setEstado (estado) {
        const cores = ESTADOS[estado] ?? ESTADOS.normal;
        const g = this.moldura.clear();
        MolduraPixel.desenhar(g, 0, 0, LARGURA, ALTURA, cores, CHANFRO);
        if (this.temRodape) {
            g.fillStyle(ARCADE_HEX.TINTA, 1).fillRect(8, 99, LARGURA - 16, 35);
            MolduraPixel.desenhar(g, 0, 0, LARGURA, ALTURA, { ...cores, fundo: null }, CHANFRO);
        }
        return this;
    }

    setTocavel (tocavel) {
        this.zona.input.enabled = tocavel;
        return this;
    }
}
